/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { DownloadIcon, SearchIcon } from '../../../assets/icons';
import { Constants, fromStorage, getUpdatedState } from '../../../utils';
import { Input, Modal, Pagination } from '../../../components';
import { MaintenanceService } from '../../../services';
import ModalViewReport from './modal-view-report';
import toast from "react-hot-toast";

const MaintenanceHistory = ({ tabs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { data, filters, goToPage, onChange, pagination, reload, search } = useFetchTable();

  const onSelectItem = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!!item);
  };

  const onPrint = async (id) => {
    try {
      const response = await MaintenanceService.moderator.downloadOne(id);
      if (response.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      toast.error(String(error));
    }
  };

  return (
    <main className="w-full">
      <Modal isOpen={isModalOpen} onClose={() => onSelectItem(null)}>
        <ModalViewReport
          item={selectedItem}
          onClose={() => onSelectItem(null)}
          onPrint={reload}
        />
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex flex-1 flex-wrap items-end gap-3">
          <Input
            className={{ base: 'max-w-60' }}
            placeholder="Buscar Propietario"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Desde"
            value={filters.since}
            onValueChange={v => onChange('since', v)}
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Hasta"
            value={filters.until}
            onValueChange={v => onChange('until', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      {tabs}

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Historial mantenimiento</p>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th><span className="pl-4">Propietario</span></th>
                <th>Placa vehículo</th>
                <th>Fecha de mantenimiento</th>
                <th>Categoría</th>
                <th>Subcategoría</th>
                <th>Estatus</th>
                <th><p className="pr-4 text-right">Acción</p></th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td>
                    <span className="pl-4">{ item?.owner?.person?.fullName || 'Maxer' }</span>
                  </td>
                  <td className="text-orange font-bold text-base">{ item?.vehicle?.plaque }</td>
                  <td>{ moment(item?.finished_at).format('DD-MM-YY') }</td>
                  <td>{ item?.category?.name }</td>
                  <td>{ item?.subcategory?.name }</td>
                  <td className="text-black font-bold">{ item?.status_text }</td>
                  <td className="!max-w-max">
                    <div className="flex justify-end items-center gap-3 pr-4">
                      {item.owner_id ? (
                        <span className="font-semibold">Realizado por el propietario</span>
                      ) : (
                        <>
                          <button
                            className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold"
                            onClick={() => onSelectItem(item)}
                          >
                            Ver reporte
                          </button>
                          <img
                            src={DownloadIcon}
                            className="w-5 h-5 object-contain cursor-pointer"
                            onClick={() => {
                              toast.promise(
                                onPrint(item?.id),
                                {
                                  loading: 'Descargando...',
                                  success: 'Reporte impreso con éxito',
                                  error: 'Error al imprimir el reporte',
                                }
                              );
                            }}
                            alt=""
                          />
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    plaque: '',
    status: Constants.MAINTENANCE.STATUS.FINISHED,
    since: '',
    until: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await MaintenanceService.moderator.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
  }
}

export default MaintenanceHistory;